import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./Auth";
import { AccessContext } from "./Auth";


const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const {currentUser} = useContext(AuthContext);
  const hasAccess = useContext(AccessContext);
  return (
    <Route
      {...rest}
      render={routeProps =>
        !!currentUser ? hasAccess ?  (
          <RouteComponent {...routeProps} />
        ) 
        : (
          <Redirect to={"/dashboard"} />
        )
        : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};


export default PrivateRoute